import type { PaymentStatus } from '@/types'

const PAYMENT_STATUS_TRANSITIONS: Record<PaymentStatus, PaymentStatus[]> = {
  pending: ['paid', 'failed'],
  failed: ['pending', 'paid'],
  paid: ['refunded'],
  refunded: [],
}

export function getAllowedPaymentStatusOptions(
  currentStatus: PaymentStatus
): PaymentStatus[] {
  return [
    currentStatus,
    ...PAYMENT_STATUS_TRANSITIONS[currentStatus].filter(
      status => status !== currentStatus
    ),
  ]
}
